<div class="question-header">
  <div class="practice-box aa-copy-size aa-contrast-invert">practice</div>
  <div *ngIf="familiarisationCheck" class="familiarisation-title aa-copy-size"><!-- contents set in _check.scss --></div>
</div>

<div class="preload" id="js-preload-div">
  <div>
    <p id="js-loading" class="text-center aa-lead-size">
      Practice question {{question.sequenceNumber}}&hellip;
    </p>
    <button *ngIf="config.nextBetweenQuestions && this.nextButtonDelayFinished"
      type="button"
      class="item-center button button-start aa-button-size aa-contrast-button aa-button-center"
      id="goButton"
      (click)="this.sendTimeoutEvent()">
      Next
    </button>
  </div>
</div>
<ng-container #modalContainer></ng-container>
